import React, { memo, useEffect, useState } from "react";
import {
  CommericalAction,
  PendingBooking,
  SelectedOffer,
} from "../../../types";
import styled from "styled-components";
import { MenuOfferCommon } from "../commercial-menu-offer-common";
import { Checkbox } from "@mui/material";
import { selectionStore } from "../../../stores/selection.store";
import {
  addOfferToPendingBooking,
  removeOfferToPendingBooking,
} from "../../../requests/pending-booking.requests";
import { Observable, Subscription } from "rxjs";
import { ApiErrorImpl } from "../../../services/api-errors/api-errors-impl";
import { pendingBookingStore } from "../../../stores/pending-booking.store";
import { useTranslation } from "react-i18next";
import { CommercialService } from "../../../services/commercial-service";
interface ICommercialsOfferItemProps {
  offer: SelectedOffer;
  setChildLoading: (state: boolean) => void;
  setErrorMessage: (errorMessage: string) => void;
}

const OfferSelection = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  margin-right: -12px;
  margin-bottom: -6px;
`;

const Item = (props: ICommercialsOfferItemProps) => {
  const [isSelected, setIsSelected] = useState(
    selectionStore.selectedOffer?.id === props.offer.id
  );
  const [action, setAction] = useState<CommericalAction | null>(null);
  const { i18n } = useTranslation();

  const commercialService = new CommercialService(props.offer, i18n.language);
  useEffect(() => {
    const subscription = selectionStore.selectedOfferChanged.subscribe(
      (selectedOffer) => {
        setIsSelected(selectedOffer?.id === props.offer.id);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  });

  useEffect(() => {
    let subscription: Subscription;
    let observable: Observable<any>;
    switch (action) {
      case "add":
        observable = addOfferToPendingBooking(props.offer.id);
        break;
      case "remove":
        observable = removeOfferToPendingBooking(props.offer.id);
        break;
    }
    observable?.subscribe({
      next: (resp: PendingBooking) => {
        action === CommericalAction.add
          ? selectionStore.addOffer(props.offer)
          : selectionStore.removeOffer();
        setAction(null);
        pendingBookingStore.pendingBooking = resp;
        props.setChildLoading(false);
      },
      error: (error: ApiErrorImpl) => {
        setAction(null);
        props.setErrorMessage(error.getMessage());
        props.setChildLoading(false);
      },
    });
    return () => {
      if (subscription) subscription.unsubscribe();
    };
  }, [action]);
  const checkboxStateChanged = (ev: any) => {
    props.setChildLoading(true);
    props.setErrorMessage(null);
    ev.target.checked
      ? setAction(CommericalAction.add)
      : setAction(CommericalAction.remove);
  };

  return (
    <MenuOfferCommon commercialService={commercialService}>
      <OfferSelection>
        <Checkbox
          data-test={`offer-check-${props.offer.id}`}
          checked={isSelected}
          onChange={checkboxStateChanged}
          size="small"
        />
      </OfferSelection>
    </MenuOfferCommon>
  );
};

export const CommercialsOfferItem = memo(Item);
